import { Box, HBox } from "../box/Box";
import Spacer from "../spacer/Spacer";
import { Typo } from "../text/Typo";
import { RecursiveCSS } from "../theme/GlobalTheme";
import type React from "react";

const DefaultSectionIcon = () => (
	<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path d="M4 13.4a8 8 0 1 1 16 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
		<path d="m12 13 3.5-3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
		<path d="M8 17h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
	</svg>
);

export const Section = (props: { children: any; sx?: RecursiveCSS; label?: string; description?: string; icon?: React.ReactNode; rightZone?: React.ReactNode }) => {
	//setup labels
	const labels = props.label && (
		<HBox sx={{ alignItems: "center", gap: "12px", minWidth: 0 }}>
			<Box
				sx={{
					alignItems: "center",
					backgroundColor: "#151922",
					borderRadius: "9px",
					color: "#ffffff",
					display: "flex",
					flexShrink: 0,
					height: "38px",
					justifyContent: "center",
					width: "38px",
				}}>
				{props.icon ?? <DefaultSectionIcon />}
			</Box>
			<Box sx={{ minWidth: 0 }}>
				<Typo
					sx={{
						color: "#07111f",
						fontSize: "22px",
						fontWeight: "800",
						lineHeight: "26px",
					}}>
					{props.label}
				</Typo>
				{props.description && <Typo sx={{ color: "#747b96", fontSize: "14px", lineHeight: "20px", marginTop: "4px" }}>{props.description}</Typo>}
			</Box>
		</HBox>
	);

	let content: JSX.Element | null = null;

	if (labels && !props.rightZone) {
		content = labels;
	}

	if (props.rightZone) {
		content = (
			<HBox sx={{ alignItems: "center", gap: "16px" }}>
				{labels}
				<Spacer grow />
				{props.rightZone}
			</HBox>
		);
	}

	//!TODO: color from theme;

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				padding: "30px",
				backgroundColor: "#f8fafc",
				borderRadius: "6px",
				//overflow: "auto",
				boxShadow: "0px 1px 2px rgba(0,0,0,.1)",
				...props.sx,
			}}>
			{content}
			{content && <Spacer size="20px" />}
			{props.children}
		</Box>
	);
};
